<template lang="html">
  <div class="Users">
    <div class="has-text-centered is-padded-medium">
      <a
        class="button is-outlined is-black is-medium is-rounded"
        @click="invite"
      >
        <span class="icon">
          <i class="las la-plus"></i>
        </span>
        <span>Invite Users</span>
      </a>
    </div>
    <cw-list-cell
      v-for="user in users"
      :key="user.uid"
      :title="user.displayName"
      :subtitle="user.email"
      :disclosureDetail="
        `${roleDisplay[user.customClaims.role || 'superintendent']}`
      "
      :showDisclosureIndicator="true"
      :showSelectedIndicator="false"
      :leftIconProps="{
        name: 'profile',
        scale: 1,
        colorClass: 'has-text-grey-light',
      }"
      class="cw-user-cell has-border-bottom"
      @click="userSelected(user)"
    >
    </cw-list-cell>
  </div>
</template>

<script>
import authRequired from '@/components/mixins/auth-required';
import permissionsRequired from '@/components/mixins/permissions-required';
import { mapState } from 'vuex';
import { RoleDisplay } from '@/enums/roles.js';

export default {
  name: 'Users',
  // share common functionality with component mixins
  mixins: [authRequired, permissionsRequired],
  props: {},
  // variables
  data: () => ({
    // users: null,
  }),
  beforeCreate() {
    // fetch on init
    this.$store.dispatch('user/loadUsers');
  },
  computed: {
    ...mapState('user', {
      token: state => state.token,
      users: state => state.users,
    }),
    roleDisplay() {
      return RoleDisplay;
    },
  },
  components: {},
  // methods
  watch: {},
  methods: {
    invite() {
      this.$modal.show('InviteUsers');
    },
    userSelected(user) {
      this.$router.push({ path: `/users/${user.uid}` });
    },
  },
};
</script>

<style lang="stylus" scoped>
.cw-user-cell {
  padding: 0.5rem;
}
</style>
